import React from "react";
import "./NavbarStyle.sass"
import users from '../../img/Navbar/users.png'
import fr from '../../img/Navbar/fr.png'
import dialogs from '../../img/Navbar/dialogs.png'
import profile from '../../img/Navbar/profile.png'
import shest from "../../img/Navbar/shest.png";
import NavbarRefs from "./NavbarRefs";
import {connect} from "react-redux";
import {editMenu} from "../../Redux/appReducer";


const Navbar = ({isMenuOpen, editMenu}) => {
    return (
        <>
            {window.innerWidth > 700 &&
            <nav className={isMenuOpen ? "navbar navbar__uncover" : "navbar navbar__cover"}>
                {isMenuOpen ?
                    <div className='navbar__burger-menu navbar__burger-menu_active'>
                        <button onClick={() => editMenu(false)}><span></span></button>
                    </div>
                    :
                    <div className='navbar__burger-menu'>
                        <button onClick={() => editMenu(true)}><span></span></button>
                    </div>
                }

                <NavbarRefs link={'/profile'} isActiveMenu={isMenuOpen} page={"Ваш профиль"} img={profile}
                            editMenu={editMenu}/>
                <NavbarRefs link={'/dialogs'} isActiveMenu={isMenuOpen} page={"Ваши диалоги"} img={dialogs}
                            editMenu={editMenu}/>
                <NavbarRefs link={'/users'} isActiveMenu={isMenuOpen} page={"Наши пользователи"} img={users}
                            editMenu={editMenu}/>
                <NavbarRefs link={'/friends'} isActiveMenu={isMenuOpen} page={"Ваши друзья"} img={fr}
                            editMenu={editMenu}/>
                <NavbarRefs link={'/settings'} isActiveMenu={isMenuOpen} page={"Ваши настройки"} img={shest}
                            editMenu={editMenu}/>

            </nav>
            }
            {window.innerWidth <= 700 &&
            <nav className={isMenuOpen ? "navbar navbar__uncover" : "navbar navbar__cover"}>
                {isMenuOpen ?
                    <>
                        <div className='navbar__burger-menu navbar__burger-menu_active'>
                            <button onClick={() => editMenu(false)}><span></span></button>
                        </div>
                        <NavbarRefs link={'/profile'} isActiveMenu={isMenuOpen} page={"Ваш профиль"} img={profile}
                                    editMenu={editMenu}/>
                        <NavbarRefs link={'/dialogs'} isActiveMenu={isMenuOpen} page={"Ваши диалоги"} img={dialogs}
                                    editMenu={editMenu}/>
                        <NavbarRefs link={'/users'} isActiveMenu={isMenuOpen} page={"Наши пользователи"} img={users}
                                    editMenu={editMenu}/>
                        <NavbarRefs link={'/friends'} isActiveMenu={isMenuOpen} page={"Ваши друзья"} img={fr}
                                    editMenu={editMenu}/>
                        <NavbarRefs link={'/settings'} isActiveMenu={isMenuOpen} page={"Ваши настройки"} img={shest}
                                    editMenu={editMenu}/>
                    </>
                    :
                    <div className='navbar__burger-menu'>
                        <button onClick={() => editMenu(true)}><span></span></button>
                    </div>
                }
            </nav>
            }

        </>
    )
};

let mapStateToProps = (state) => {
    return{
        isMenuOpen: state.appReducer.isMenuOpen

    }
};

export default connect(mapStateToProps, {editMenu})(Navbar);